import aspnet from "assets/img/tech_stack/aspnet.png";
import java from "assets/img/tech_stack/java.png";
import nodejs from "assets/img/tech_stack/icon-nodejs.png";
import django from "assets/img/tech_stack/django.jpg";
import laravel from "assets/img/tech_stack/icon-laravel.png";
import Python from "assets/img/tech_stack/Python-logo-notext.svg.png";
import ruby from "assets/img/tech_stack/ruby.png";
import scala from "assets/img/tech_stack/scala.png";
import golang from "assets/img/tech_stack/golang.png";
import flask from "assets/img/tech_stack/flask.png";
import springboot from "assets/img/tech_stack/springboot.png";

const textProps = {
  heading3: {
    title: "Back-End",
    alignment: "center",
  },

  infoAreas: [
    {
      image: aspnet,
      name: "AspNet",
    },
    {
      image: java,
      name: "Java",
    },
    {
      image: nodejs,
      name: "NodeJs",
    },
    {
      image: django,
      name: "Django",
    },
    {
      image: laravel,
      name: "Laravel",
    },
    {
      image: Python,
      name: "Python",
    },
    {
      image: ruby,
      name: "Ruby",
    },
    {
      image: scala,
      name: "Scala",
    },
    {
      image: golang,
      name: "GoLang",
    },
    {
      image: flask,
      name: "Flask",
    },
    {
      image: springboot,
      name: "Spring Boot",
    },
  ],
};
export default textProps;
